import React from 'react'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles({
  root:{
    padding: 10, 
    fontSize: 48, 
    fontFamily: 'Montserrat', 
    boxSizing: 'border-box', 
    textAlign: 'center'
  }
})

export default function Header(props){

  const classes = useStyles()

  const { title } = props

  return (
    <div className={classes.root}>
      {title}
    </div>
  )
}